import React from "react";
import PropTypes from "prop-types";
import AccessDenied from "@routes/errors/Error403";
import Error404 from "@routes/errors/Error404";
import Error500 from "@routes/errors/Error500";

const ErrorView = ({ status }) => {
    // 401(인증 실패)은 리소스 접근 거부 성격이라 403과 동일하게 표시 (선례: routes/asset/Detail.js)
    if (status === 401 || status === 403) return <AccessDenied />;
    if (status === 404) return <Error404 />;
    return <Error500 />;
};

ErrorView.propTypes = {
    status: PropTypes.number,
};

export default ErrorView;
